<div class="template-nsla-container wrap-{{ templateNameFirst }}">
    <slide-elements (clickActive)="setClickActive($event)" [hideScroll]="(isMobile$ | async) === false" [customScroll]="true">
        <div *ngFor="let product of products" class="product-item">
            <product-view
                class="full-size"
                [ngStyle]="{ 'pointer-events': clickActive ? 'all' : 'none' }"
                [productId]="product"
                [config]="templateConfiguration$ | async"
                [categoryConfig]="categoryConfiguration"
                [productStyle]="productStyle"
                [defaultImageType]="elementDefaultImageTypes?.[product]"
                (clickActionBadge)="addToCartSheet($event)"
            ></product-view>
        </div>
    </slide-elements>
</div>
